<template>
    <div class="kv-filter-container">
        <div class="kv-filter-label">{{ label }}</div>

        <KvPopup max-width="400px" min-width="280px" ref="popup">
            <template #trigger="{ toggle }">
                <span class="kv-filter-input" :title="valueLabel" @click="toggle">
                    <Icon :icon-class="triggerIcon" size="2" />
                    {{ valueLabel }}
                    <span class="kv-remove-filter" v-if="removable" @click.stop="$emit('remove')">
                        <Icon icon-class="ui-x-close" size="2" color="#212529" />
                    </span>
                </span>
            </template>

            <template #content="{ toggle }">
                <div class="kv-select-options">
                    <KvInput
                        v-if="showSearch"
                        v-model="searchQuery"
                        :placeholder="t('reportFilters-search_placeholder')"
                    >
                        <template #prepend>
                            <Icon icon-class="ui-search-01" size="2" />
                        </template>
                    </KvInput>

                    <div class="kv-options">
                        <KvButton
                            v-for="(option, index) in filteredOptions"
                            :key="index"
                            alignment="left"
                            variant="tonal"
                            :active="String(option.value) === String(value)"
                            @click="selectOption(option.value, toggle)"
                        >
                            {{ option.label }}
                        </KvButton>
                    </div>
                </div>
            </template>
        </KvPopup>
    </div>
</template>

<style lang="less">
.kv-select-options {
    display: flex;
    flex-direction: column;
    gap: 12px;
}
</style>

<script>
import KvButton from "../../form/kv-button.vue";
import Icon from "../../icon/icon";
import KvInput from "../../inputs/kv-input.vue";
import KvPopup from "../../ui/kv-popup";

export default {
    name: "kv-select-filter",
    components: {
        Icon,
        KvPopup,
        KvInput,
        KvButton,
    },
    props: {
        options: {
            type: [Object, Array],
            default: () => ({}),
        },
        name: {
            type: String,
            default: "kv-select",
        },
        currentValue: {
            type: [String, Number],
            default: null,
        },
        label: {
            type: String,
            default: "",
        },
        removable: Boolean,
        searchable: {
            type: Boolean,
            default: undefined,
        },
    },
    data() {
        return {
            value: null,
            searchQuery: "",
            focus: false,
        };
    },
    mounted() {
        if (this.currentValue !== null && this.currentValue !== undefined && this.currentValue !== "") {
            this.value = String(this.currentValue);
        }
        if (this.value !== null && this.value !== undefined && String(this.value).length > 0) {
            this.changed();
        }
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        selectOption(value, toggle) {
            this.value =
                value === null || value === undefined ? null : String(value);
            this.searchQuery = "";
            if (typeof toggle === "function") {
                toggle(false);
            }
        },
        changed() {
            this.$emit(
                "changed",
                this.value !== null &&
                    this.value !== undefined &&
                    String(this.value).length > 0
                    ? this.value
                    : null,
            );
        },
    },
    computed: {
        triggerIcon() {
            return (this.options && this.options.icon) || "ui-chevron-down";
        },
        showSearch() {
            if (typeof this.searchable === "boolean") {
                return this.searchable;
            }
            if (
                this.options &&
                typeof this.options === "object" &&
                !Array.isArray(this.options) &&
                typeof this.options.searchable === "boolean"
            ) {
                return this.options.searchable;
            }
            return true;
        },
        normalizedOptions() {
            if (Array.isArray(this.options)) return this.options;
            if (this.options && Array.isArray(this.options.options)) return this.options.options;
            return [];
        },
        optionsMap() {
            let optionsMap = {};
            for (let o in this.normalizedOptions) {
                let option = this.normalizedOptions[o];
                optionsMap[String(option.value)] = option.label;
            }
            return optionsMap;
        },
        valueLabel() {
            if (this.value === null || this.value === undefined || String(this.value).length === 0) {
                return this.t('reportFilters-select');
            }
            let label = this.optionsMap[String(this.value)] || this.t('reportFilters-select');
            if (label.length > 30) {
                label = label.substr(0, 27) + "...";
            }
            return label;
        },
        filteredOptions() {
            const list = this.normalizedOptions;
            if (!this.showSearch || !this.searchQuery) {
                return list;
            }
            return list.filter((option) =>
                String(option.label || "").toLowerCase().includes(this.searchQuery.toLowerCase())
            );
        },
    },
    watch: {
        value() {
            this.changed();
        },
        focus(newValue) {
            this.$refs.popup.toggleShow(newValue);
        },
        currentValue(newValue) {
            if (newValue === null || newValue === undefined || newValue === "") {
                this.value = null;
                return;
            }
            const next = String(newValue);
            if (next !== this.value) {
                this.value = next;
            }
        },
    },
};
</script>
